import { Model } from "./model";
import { Box } from "./box";

export class Sim extends Model {

  expirationDate?: Date;

  identifier?: string;

  dataUsage?: number;

  maxDataUsable?: number;

  simOperator?: string;

  monthlyFee?: number;

  status?: string;

  box?: Box;

}
